import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Online from "@/pages/Online";
import Members from "@/pages/Members";
import Reservar from "@/pages/Reservar";
import RouteTracker from "@/components/site/RouteTracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reservar" element={<Reservar />} />
          <Route path="/online" element={<Online />} />
          <Route path="/online/members" element={<Members />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F6F4EE",
            border: "none",
            borderRadius: "999px",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "0.78rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            padding: "0.95rem 1.5rem",
          },
        }}
      />
    </div>
  );
}

export default App;
